import React from 'react';

const DownloadPopup = ({ onClose, downloadApp }) => {
    // Simple test handler to verify button is clickable
    // const handleTestClick = (event) => {
    //     console.log('TEST: Button clicked!', event);
    //     alert('Button is clickable! Test successful.');
    //     event.stopPropagation();
    // };

    const handleDownloadClick = (event) => {
        console.log('Download button clicked in popup');
        console.log('downloadApp function:', downloadApp);
        console.log('Event:', event);

        // Stop event propagation to prevent backdrop click
        event.stopPropagation();

        if (downloadApp && typeof downloadApp === 'function') {
            try {
                downloadApp();
            } catch (error) {
                console.error('Error calling downloadApp:', error);
                alert('Error occurred while trying to open store');
            }
        } else {
            console.error('downloadApp function not available');
            alert('Download function not available. Function type: ' + typeof downloadApp);
            // Fallback - at least close the popup
            if (onClose && typeof onClose === 'function') {
                onClose();
            }
        }
    };

    const handleBackdropClick = (event) => {
        console.log('Backdrop clicked');
        if (onClose && typeof onClose === 'function') {
            onClose();
        }
    };

    // Render debug info
    console.log('DownloadPopup rendered with props:', { onClose: typeof onClose, downloadApp: typeof downloadApp });

    return (
        <div className="download-popup">
            <div className="popup-backdrop" onClick={handleBackdropClick}></div>
            <div className="popup-content">
                <button className="popup-close-btn" onClick={onClose}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path d="M18 6L6 18M6 6l12 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
                <div className="popup-emoji">
                    <img src="assets/images/ui/download_pov_emoj.png" alt="Download POV" />
                </div>
                <div className="popup-message">
                    More vibe options<br/>
                    available on POV app
                </div>
                <button
                    className="popup-download-btn"
                    onClick={handleDownloadClick}
                    onMouseDown={(e) => console.log('Mouse down on button', e)}
                    onTouchStart={(e) => console.log('Touch start on button', e)}
                    style={{ cursor: 'pointer', position: 'relative', zIndex: 10 }}
                >
                    Download POV
                </button>
                {/* Test button for debugging */}
                {/* <button 
                    onClick={handleTestClick}
                    style={{ 
                        margin: '10px 0', 
                        padding: '10px', 
                        backgroundColor: 'red', 
                        color: 'white',
                        cursor: 'pointer'
                    }}
                >
                    TEST CLICK
                </button> */}
            </div>
        </div>
    );
};

export default DownloadPopup;